export default "__VITE_ASSET__87Ub7QOJ__"